import { useState } from "react";

export default function Player({
  initialName,
  symbol,
  isActive,
  onChangeName,
}) {
  const [nameChange, setNameChange] = useState(initialName);
  const [isEditing, setIsEditing] = useState(false);

  function handleClick() {
    setIsEditing((editing) => !editing);

    if (isEditing) {
      onChangeName(symbol, nameChange);
    }
  }

  function handleNameChange(event) {
    setNameChange(event.target.value);
  }

  return (
    <li className={isActive ? "active" : undefined}>
      <span className="player">
        {isEditing ? (
          <input
            type="text"
            value={nameChange}
            onChange={handleNameChange}
            required
          />
        ) : (
          <span className="player-name">{nameChange}</span>
        )}

        <span className="player-sysmbol">{symbol}</span>
      </span>
      <button onClick={() => handleClick()}>
        {isEditing ? "Save" : "Edit"}
      </button>
    </li>
  );
}
